module.exports = __webpack_public_path__ + "static/media/group.c1562c1c.png";